import { generateScopeString, getPingManager, pingThroughSwInternalChannel, } from '../../../file-contexts-common';
import { SwToMainBroadcastMessageTypes } from '../../constants';
import { startSWAndWaitOnActivate } from '../startSWAndWaitOnActivate';
export const setupDownloadServiceWorker = async ({ abortController, scope, }) => {
    const { promise: activationPromise, resolve: activationResolver } = Promise.withResolvers();
    const swBroadcastChannel = new BroadcastChannel(scope);
    let isCancelledByBrowser = false;
    swBroadcastChannel.onmessage = (event) => {
        const [type] = event.data;
        switch (type) {
            case SwToMainBroadcastMessageTypes.ACTIVATION:
                activationResolver();
                break;
            case SwToMainBroadcastMessageTypes.STREAM_CANCELLED:
                isCancelledByBrowser = true;
                abortController.abort();
                break;
            default:
                break;
        }
    };
    try {
        const registration = await startSWAndWaitOnActivate({
            activationPromise,
            scope: generateScopeString(scope),
        });
        let swInstanceId = null;
        const pingManager = getPingManager({
            pingFn: (id) => {
                void pingThroughSwInternalChannel(registration, ({ instanceId }) => {
                    swInstanceId ??= instanceId;
                    if (instanceId !== swInstanceId) {
                        abortController.abort(new Error(`Service worker was terminated: instance changed from ${swInstanceId} to ${instanceId}`));
                        return;
                    }
                    pingManager.acknowledgePing(id);
                });
            },
        });
        return {
            isCancelledByBrowser: () => isCancelledByBrowser,
            pingManager,
            registration,
            scope,
            swBroadcastChannel,
        };
    }
    catch (error) {
        // eslint-disable-next-line no-console -- Let's see how to handle, we don't have custom errors yet
        console.error('Error while setting up worker:', error);
        swBroadcastChannel.close();
        throw error;
    }
};
